import { RouterProvider, createRouter } from '@tanstack/react-router'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { z } from 'zod'

import { getQueryClient } from '@/features/_lib/react-query'
import { zodPtBrErrorMap } from './_lib/zod-error-map'
import './globals.css'
import { routeTree } from './routeTree.gen'

z.config({ customError: zodPtBrErrorMap })

const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPendingMs: 0,
  context: { queryClient: getQueryClient() },
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
)
